import {
  ApartmentOutlined,
  BarChartOutlined,
  CalendarOutlined,
  SendOutlined,
  CheckSquareOutlined,
  DashboardOutlined,
  FormOutlined,
  GlobalOutlined,
  InboxOutlined,
  ShopOutlined,
  TeamOutlined,
  UnorderedListOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { BaseSidebar } from '@/components/layouts/base-sidebar';
import { getItem, type MenuItem } from '@/components/layouts/sidebar-utils';
import { useProgressRouter } from '@/hooks/use-progress-router';
import { useScope } from '@/hooks/use-scope';

export function OrgSidebar() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const router = useProgressRouter();
  const { organizationSlug } = useScope();
  const slug = organizationSlug as string;

  const mainMenuItems: MenuItem[] = [
    getItem(
      t('navigation.dashboard'),
      `/org/${slug}`,
      <DashboardOutlined />,
      undefined,
      {
        onClick: () => router.push(`/org/${slug}`),
      },
    ),
    getItem(
      t('navigation.tasks'),
      `/org/${slug}/tasks`,
      <CheckSquareOutlined />,
      undefined,
      { onClick: () => router.push(`/org/${slug}/tasks`) },
    ),
    getItem(
      t('navigation.organization'),
      `/org/${slug}/organization`,
      <ApartmentOutlined />,
      undefined,
      { onClick: () => router.push(`/org/${slug}/organization`) },
    ),
    getItem(
      t('navigation.fleet'),
      `/org/${slug}/fleet`,
      <SendOutlined />,
      undefined,
      {
        onClick: () => router.push(`/org/${slug}/fleet`),
      },
    ),
    getItem(
      t('navigation.flightList'),
      `/org/${slug}/flight-list`,
      <UnorderedListOutlined />,
      undefined,
      { onClick: () => router.push(`/org/${slug}/flight-list`) },
    ),
    getItem(
      t('navigation.applications'),
      `/org/${slug}/applications`,
      <FormOutlined />,
      undefined,
      { onClick: () => router.push(`/org/${slug}/applications`) },
    ),
    getItem(
      t('navigation.crew'),
      `/org/${slug}/crew`,
      <TeamOutlined />,
      undefined,
      {
        onClick: () => router.push(`/org/${slug}/crew`),
      },
    ),
    getItem(
      t('navigation.countries'),
      `/org/${slug}/country`,
      <GlobalOutlined />,
      undefined,
      { onClick: () => router.push(`/org/${slug}/country`) },
    ),
    getItem(
      t('navigation.serviceProviders'),
      `/org/${slug}/service-providers`,
      <ShopOutlined />,
      undefined,
      {
        onClick: () => router.push(`/org/${slug}/service-providers`),
      },
    ),
    getItem(
      t('navigation.cargo'),
      `/org/${slug}/cargo`,
      <InboxOutlined />,
      undefined,
      {
        onClick: () => router.push(`/org/${slug}/cargo`),
      },
    ),
    getItem(
      t('navigation.charter'),
      `/org/${slug}/charterers`,
      <CalendarOutlined />,
      undefined,
      { onClick: () => router.push(`/org/${slug}/charterers`) },
    ),
    getItem(
      t('navigation.users'),
      `/org/${slug}/users`,
      <TeamOutlined />,
      undefined,
      {
        onClick: () => router.push(`/org/${slug}/users`),
      },
    ),
    getItem(
      t('navigation.analytics'),
      `/org/${slug}/analytics`,
      <BarChartOutlined />,
      undefined,
      { onClick: () => router.push(`/org/${slug}/analytics`) },
    ),
  ];

  const getSelectedKeys = () => {
    // Extract keys and sort by length descending to match most specific path first
    const keys = mainMenuItems
      .filter(
        (item): item is MenuItem & { key: string } =>
          item !== null && typeof item === 'object' && 'key' in item,
      )
      .map((item) => item.key as string)
      .sort((a, b) => b.length - a.length);

    // Check for exact matches or startsWith for sub-routes
    for (const key of keys) {
      if (pathname === key || pathname.startsWith(key + '/')) {
        return [key];
      }
    }
    return [pathname];
  };

  return (
    <BaseSidebar menuItems={mainMenuItems} getSelectedKeys={getSelectedKeys} />
  );
}
